import { BODY_SM_SM_MEDIUM_STYLES, BODY_XS_XS_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const CustomSelectDropdownWrapper = styled.div`
    padding: var(--spacing-xs, 8px);
`;

export const Option = styled.div`
    border-radius: var(--border-radius-xs_4, 4px);
    background: var(--colors-surface-primary, #fff);
    cursor: pointer;
    padding: 10px 16px;

    &:hover {
        background: var(--colors-surface-page, #e7f4ff);
    }
`;

export const Label = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_MEDIUM_STYLES};
    font-size: 14px !important;
    margin-bottom: 4px;
`;

export const SubLabel = styled.div`
    color: var(--colors-text-on-disabled, #70768d);
    ${BODY_XS_XS_STYLES};
    font-size: 12px !important;
`;
